
import { mapState, mapActions } from "vuex";
import bulkEdit from "../../components/bulk-edit/bulk-edit.vue";
export default {
  components: { bulkEdit },
  data() {
    return {
      loading: false
    };
  },
  async fetch() {
    this.loading = true;
    await this.getMenuList();
    this.loading = false;
  },
  computed: {
    ...mapState("menu", ["menuLoading"])
  },
  methods: {
    ...mapActions("menu", ["getMenuList"])
  }
};
